import React, { useState, useEffect } from 'react';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import { settingsAPI } from '../services/api';

const Settings = () => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [name, setName] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    fetchProfile();
  }, []);

  const fetchProfile = async () => {
    try {
      setLoading(true);
      const response = await settingsAPI.getProfile();
      const profileData = response.data.profile;
      
      setName(profileData.name || '');
    } catch (error) {
      console.error('Error fetching profile:', error);
      setError('Failed to load profile');
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    try {
      setSaving(true);
      setError('');
      setMessage('');

      if (!name.trim()) {
        setError('Name is required');
        return;
      }

      await settingsAPI.updateProfile({ name: name.trim() });
      setMessage('Name updated successfully!');
    } catch (error) {
      console.error('Error updating profile:', error);
      setError(error.response?.data?.error || 'Failed to update name');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div style={{width: '100%', height: '100%', position: 'relative', background: 'white'}}>
        <Sidebar />
        <div style={{marginLeft: 290, padding: '40px'}}>
          <div style={{textAlign: 'center', padding: '40px'}}>Loading...</div>
        </div>
      </div>
    );
  }

  return (
    <div style={{width: '100%', height: '100%', position: 'relative', background: 'white', overflow: 'hidden'}}>
      <Sidebar />
      
      <div style={{marginLeft: 290, width: 'calc(100% - 290px)', minHeight: '100vh', background: 'white', position: 'relative'}}>
        <Header />

        {/* Page Title */}
        <div style={{padding: '20px 40px'}}>
          <h1 style={{fontSize: 24, fontFamily: 'Outfit', fontWeight: '700'}}>Settings</h1>
        </div>

        {/* Messages */}
        {message && (
          <div style={{margin: '0 40px 20px', padding: '10px', background: '#e8f5e8', color: '#2e7d32', borderRadius: 6}}>
            {message}
          </div>
        )}
        
        {error && (
          <div style={{margin: '0 40px 20px', padding: '10px', background: '#ffebee', color: '#d32f2f', borderRadius: 6}}>
            {error}
          </div>
        )}

        {/* Settings Content */}
        <div style={{margin: '0 40px'}}>
          <div style={{background: '#F04915', borderTopLeftRadius: 15, borderTopRightRadius: 15, padding: '20px'}}>
            <h2 style={{color: 'white', fontSize: 24, fontFamily: 'Outfit', fontWeight: '700'}}>Personal Settings</h2>
          </div>

          <div style={{background: '#FFFBF5', padding: '40px'}}>
            {/* Name Update Section */}
            <div style={{marginBottom: '40px', maxWidth: '400px'}}>
              <h3 style={{fontSize: 20, fontFamily: 'Outfit', fontWeight: '500', marginBottom: '20px'}}>Update Name</h3>
              
              <div>
                <label style={{display: 'block', marginBottom: '8px', color: 'black', fontSize: 16, fontFamily: 'Outfit', fontWeight: '500'}}>
                  Full Name
                </label>
                <input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Enter your full name"
                  style={{
                    width: '100%', 
                    height: 49, 
                    padding: '0 15px', 
                    borderRadius: 8, 
                    border: '1px solid #77838F',
                    fontSize: 16,
                    fontFamily: 'Outfit'
                  }}
                />
              </div>
            </div>

            {/* Save Button */}
            <div>
              <button 
                onClick={handleSave}
                disabled={saving || !name.trim()}
                style={{
                  width: 200,
                  padding: '11px 20px',
                  background: saving || !name.trim() ? '#ccc' : '#F04915',
                  border: 'none',
                  borderRadius: 8,
                  color: 'white',
                  fontSize: 16,
                  fontFamily: 'Outfit',
                  fontWeight: '500',
                  cursor: saving || !name.trim() ? 'not-allowed' : 'pointer'
                }}
              >
                {saving ? 'Saving...' : 'Save Changes'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
